module.exports = __webpack_public_path__ + "static/media/start-button.b9e1bb9f.png";